const MIN_EMAIL_FILTER_LENGTH = 3;

export {
  MIN_EMAIL_FILTER_LENGTH // min email length depends on the backend
}
